import React from 'react';
import './vahan-taran-karj.css';

const VahanTaranKarj = () => {
  return (
    <div className="vehicle-loan-container">
    <div className="banner">
      <img src="/images/slider1.jpg" alt="Banner" className="banner" />
    </div>
    
      <h1>वाहन तारण कर्ज</h1>
      <p>
        किती लोकांचा व्यवसाय आपल्या वाहनांवरच अवलंबून असतो तर कित्येकजण आपलं स्वतःचं वाहन असावं असं स्वप्न पाहतात.
        आता त्यांची स्वप्न साकार होईल <strong>श्री वरद विनायक पतसंस्थेच्या वाहन तारण कर्जामुळे</strong>. 
        आम्ही नवीन व जुन्या वाहनांवर तारण कर्ज <strong>कमी वेळेत</strong> मंजूर करून देतो.
      </p>

      {/* <ul>
        <li>वाहनाच्या किंमतीचे कोटेशन (ऑन रोड किंमत)</li>
        <li>कोटेशनच्या 25% रक्कम संस्थेकडे जमा करावी</li>
        </ul>
        <ul>
        <li>500 रुपये चे दोन स्टॅम्प पेपर</li>
        <li>इतर संस्थेची (NOC)</li>
      </ul>
      <ul>
        <li>पोस्टाचे 4 तिकीट</li>
        <li>15 चेक</li>
      </ul>
      <ul>
        <li>2 फोटो</li>
        <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
      </ul>  */}

      <h1>आवश्यक कागदपत्रे :</h1>
      <div className="documents-container">
      <div className="documents-column">
        <ul>
          <li>वाहनाच्या किमतीचे कोटेशन (ऑन रोड किम्मत)</li>
          <li>500 रुपयांचे दोन स्टॅम्प पेपर</li>
          <li>पोस्टाचे 4 तिकीट</li>
          <li>2 फोटो</li>
          <li>कोटेशनच्या 25% रक्कम संस्थेकडे जमा करावी</li>
          <li>इतर संस्थेची (NOC)</li>
          <li>15 चेक</li>
          <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
        </ul>
      </div>
      {/* <div className="documents-column">
        <ul>
          <li>कोटेशनच्या 25% रक्कम संस्थेकडे जमा करावी</li>
          <li>इतर संस्थेची (NOC)</li>
          <li>15 चेक</li>
          <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
        </ul>
      </div> */}
    </div>

    </div>
  );
};

export default VahanTaranKarj;
